/*
  Shopify's Liquid `product.price` only knows about variant prices, so it never
  reflects an automatic discount (the Labor Day sale is one). The rest of the
  store solves this client side in bch-automatic-discount-prices.js, but that
  script only rewrites `[data-discount-element]` on product templates, and this
  landing page is a page template. So mirror the same rules here, scoped to the
  offer section: same endpoint, same `preview-sale-dc` override, same market and
  item gating, same percentage maths.

  Nothing is rewritten unless a discount is actually running and covers this
  product and market, so when the sale ends the page keeps the price Shopify
  rendered. That is the fallback for every failure too: no discount in the
  response, an unparseable price, a request that never comes back.
*/
(function () {
  var ENDPOINT = 'https://boncharge.io/=/api/getautomaticdiscount';

  /*
    bch-automatic-discount-prices.js stops honouring these two named sales
    outside a hardcoded window, whatever the API still returns. Mirror it, or
    this page could keep advertising a sale price the PDP and the cart no longer
    give. Keep in sync with init() in that file; drop an entry once its sale is
    retired from the API.
  */
  var SALE_WINDOWS = {
    LABORDAY26: { start: '2026-08-03T15:00:00+08:00', end: '2026-09-13T23:59:59+08:00' },
    'BONCHARGE SALE': { start: '2026-08-03T15:00:00+08:00', end: '2026-09-13T23:59:59+08:00' }
  };

  var root = document.querySelector('[data-acc-boncharge-lp-01-price]');
  if (!root) return;

  var nowEl = root.querySelector('.acc-boncharge-lp-01-offer__price-now');
  if (!nowEl) return;

  var handle = root.getAttribute('data-handle') || '';
  var market = (root.getAttribute('data-market') || '').toUpperCase();
  var cents = parseInt(root.getAttribute('data-cents'), 10);
  var regular = nowEl.textContent.trim();
  if (!(cents > 0) || !regular) return;

  /* Rebuild the sale price from the price Shopify already rendered, so the
     currency symbol, code, separators and decimal places follow the market the
     visitor is browsing rather than a hardcoded format. */
  function money(sample, newCents) {
    var match = sample.match(/\d[\d., \s']*\d|\d/);
    if (!match) return null;

    var digits = match[0];
    var decimals = digits.match(/([.,])(\d{1,2})$/);
    var decimalSeparator = decimals ? decimals[1] : '.';
    var precision = decimals ? decimals[2].length : 0;
    var thousandSeparator = decimalSeparator === ',' ? '.' : ',';
    if (digits.indexOf(' ') > -1) thousandSeparator = ' ';
    else if (/\d\s\d/.test(digits)) thousandSeparator = ' ';
    else if (digits.indexOf("'") > -1) thousandSeparator = "'";

    var amount = (newCents / 100).toFixed(precision).split('.');
    var whole = amount[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandSeparator);
    var formatted = whole + (amount[1] ? decimalSeparator + amount[1] : '');

    return sample.slice(0, match.index) + formatted + sample.slice(match.index + digits.length);
  }

  /* True only while the sale is live. An absent or unreadable date is not a
     reason to run a sale, so anything we cannot parse counts as expired. */
  function running(discount) {
    var now = Date.now();
    var saleWindow = SALE_WINDOWS[discount.title];

    if (saleWindow) {
      if (!(now >= Date.parse(saleWindow.start) && now <= Date.parse(saleWindow.end))) return false;
    }

    var startsAt = discount.starts_at || discount.startsAt;
    if (startsAt && !(now >= Date.parse(startsAt))) return false;

    var endsAt = discount.ends_at || discount.endsAt;
    if (endsAt && !(now <= Date.parse(endsAt))) return false;

    return true;
  }

  function applies(discount) {
    if (!discount || discount.type !== 'percentage') return false;
    if (!(discount.value > 0) || discount.value >= 1) return false;
    if (!running(discount)) return false;

    var marketsOnly = discount.markets_only || [];
    if (marketsOnly.length && marketsOnly.indexOf(market) === -1) return false;

    var markets = discount.markets || [];
    var condition = discount.marketsCondition || 'include';
    if (markets.length && condition === 'include' && markets.indexOf(market) === -1) return false;
    if (markets.length && condition === 'exclude' && markets.indexOf(market) > -1) return false;

    /* An empty items list means the discount is sitewide. */
    var items = discount.items || [];
    if (items.length && items.indexOf(handle) === -1) return false;

    return true;
  }

  function apply(discount) {
    var saleCents = Math.round(cents * (1 - discount.value));
    if (!(saleCents > 0) || saleCents >= cents) return;

    var sale = money(regular, saleCents);
    if (!sale) return;

    nowEl.textContent = sale;
    root.classList.add('acc-boncharge-lp-01-offer__price--on-sale');

    var offer = document.getElementById('acc-boncharge-lp-01-offer');
    if (offer) offer.setAttribute('data-price', sale);

    document.dispatchEvent(
      new CustomEvent('acc-boncharge-lp-01:price-change', { detail: { price: sale, compareAt: regular } })
    );
  }

  /* ?preview-sale-dc=25 previews a 25% sale, same as the rest of the theme. */
  var preview = new URLSearchParams(window.location.search).get('preview-sale-dc');
  if (preview) {
    apply({ type: 'percentage', value: (preview * 1) / 100, items: [], markets_only: [] });
    return;
  }

  /* window.bchFetchApi (snippets/bch-automatic-discount-prices.liquid) falls back to fly.io when
     boncharge.io is down. */
  var url = ENDPOINT + '?market=' + encodeURIComponent(market);
  (window.bchFetchApi
    ? window.bchFetchApi(url)
    : fetch(url, { method: 'GET' }).then(function (response) {
        return response.json();
      }))
    .then(function (data) {
      if (!data || !data.discount) return;
      var discounts = Array.isArray(data.discount) ? data.discount : [data.discount];
      var best = discounts.filter(applies).sort(function (a, b) {
        return b.value - a.value;
      })[0];
      if (best) apply(best);
    })
    .catch(function (error) {
      console.error('acc-boncharge-lp-01 offer price:', error);
    });
})();
